/*
 * Copyright (c) 2018-2999 广州市蓝海创新科技有限公司 All rights reserved.
 *
 * https://www.mall4j.com/
 *
 * 未经允许，不可做商业用途！
 *
 * 版权所有，侵权必究！
 */

// 获取购物车数字
import { queryCartCount } from '@/api/modules/mall4cloud_product.js'

// tabBar: 首页(0) 购物车(1) 我的(2), 分类页已迁出tabBar
const cartTabIndex = 1

// tabBar页面路由, 角标API只能在这些页面调用, 其它页面调用会报 fail not TabBar page
const TAB_BAR_ROUTES = ['pages/index/index', 'pages/cart/cart', 'pages/my/my']

const isTabBarPage = () => {
  const pages = getCurrentPages()
  return TAB_BAR_ROUTES.includes(pages[pages.length - 1]?.route)
}

const removeCartBadge = () => {
  uni.removeTabBarBadge({
    index: cartTabIndex,
    fail: () => {}
  })
}

/**
 * 生成购物车数量汇总
 * @param {Number} shoppingCount 购物商品数量
 * @param {Number} flashCount 闪购商品数量
 * @return {Object} 购物车数量汇总
 */
const createCartCountSummary = (shoppingCount = 0, flashCount = 0) => {
  const shopping = Number(shoppingCount || 0)
  const flash = Number(flashCount || 0)
  return {
    shoppingCount: shopping,
    flashCount: flash,
    totalCount: shopping + flash
  }
}

/**
 * 获取购物与闪购购物车数量，并同步原生 tabBar 角标
 * @return {Promise<Object|null>} 购物车数量汇总，非 tabBar 页面或请求失败时返回 null
 */
async function getCartCount () {
  // 非tabBar页面无法操作角标, 直接跳过(回到tabBar页面时各页onShow会重新刷新)
  if (!isTabBarPage()) return null
  if (!uni.getStorageSync('cloudToken')) {
    removeCartBadge()
    return createCartCountSummary()
  }
  const params = {
    data: {
      type: 0,
      usage: 1
    }
  }
  const flashParams = {
    data: {
      type: 0,
      usage: 2
    }
  }
  try {
    const [shoppingCount, flashCount] = await Promise.all([
      queryCartCount(params),
      queryCartCount(flashParams)
    ])
    const summary = createCartCountSummary(shoppingCount, flashCount)
    if (summary.totalCount) {
      uni.setTabBarBadge({
        index: cartTabIndex,
        text: summary.totalCount > 99 ? '99+' : summary.totalCount + '',
        fail: () => {}
      })
    } else {
      removeCartBadge()
    }
    return summary
  } catch (error) {
    removeCartBadge()
    return null
  }
}
export { getCartCount }
